import React from 'react';
import { Search, Download, ChevronLeft, ChevronRight } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '../../ui/select';

export const UserFilters = ({
  searchQuery,
  setSearchQuery,
  statusFilter,
  setStatusFilter,
  roleFilter,
  setRoleFilter,
  onSearch,
  onApplyFilters,
  onExportCSV,
  totalUsers
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    onSearch();
  };

  return (
    <div className="mb-4 md:mb-6">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 mb-4">
        <div>
          <h2 className="text-xl md:text-3xl font-bold text-white mb-1 md:mb-2">User Management</h2>
          <p className="text-sm text-gray-400">Manage all platform users ({totalUsers} total)</p>
        </div>
        <Button
          onClick={onExportCSV}
          variant="outline"
          size="sm"
          className="border-green-500 text-green-400 hover:bg-green-900/20"
        >
          <Download className="w-4 h-4 mr-2" />
          Export CSV
        </Button>
      </div>
      
      <div className="flex flex-col sm:flex-row gap-3">
        <form onSubmit={handleSubmit} className="relative flex-1">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 w-4 h-4 text-gray-400" />
          <Input
            type="text"
            placeholder="Search users..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="pl-9 bg-gray-800 border-gray-600 text-white text-sm"
          />
        </form>
        
        <div className="flex gap-2 flex-wrap">
          <Select value={statusFilter} onValueChange={setStatusFilter}>
            <SelectTrigger className="w-32 bg-gray-800 border-gray-600 text-white text-sm">
              <SelectValue placeholder="Status" />
            </SelectTrigger>
            <SelectContent className="bg-gray-800 border-gray-700 text-white">
              <SelectItem value="all">All Status</SelectItem>
              <SelectItem value="active">Active</SelectItem>
              <SelectItem value="suspended">Suspended</SelectItem>
            </SelectContent>
          </Select>
          
          <Select value={roleFilter} onValueChange={setRoleFilter}>
            <SelectTrigger className="w-32 bg-gray-800 border-gray-600 text-white text-sm">
              <SelectValue placeholder="Role" />
            </SelectTrigger>
            <SelectContent className="bg-gray-800 border-gray-700 text-white">
              <SelectItem value="all">All Roles</SelectItem>
              <SelectItem value="admin">Admin</SelectItem>
              <SelectItem value="artist">Artist</SelectItem>
              <SelectItem value="moderator">Moderator</SelectItem>
              <SelectItem value="user">User</SelectItem>
            </SelectContent>
          </Select>
          
          <Button onClick={onApplyFilters} variant="outline" size="sm" className="border-gray-600">
            Apply
          </Button>
        </div>
      </div>
    </div>
  );
};

export const UserPagination = ({
  currentPage,
  setCurrentPage,
  totalUsers,
  pageSize
}) => {
  const totalPages = Math.ceil(totalUsers / pageSize);

  return (
    <div className="flex items-center justify-between mt-4">
      <p className="text-sm text-gray-400">
        Showing {currentPage * pageSize + 1} to {Math.min((currentPage + 1) * pageSize, totalUsers)} of {totalUsers} users
      </p>
      <div className="flex items-center gap-2">
        <Button
          onClick={() => setCurrentPage(p => Math.max(0, p - 1))}
          disabled={currentPage === 0}
          variant="outline"
          size="sm"
          className="border-gray-600"
        >
          <ChevronLeft className="w-4 h-4" />
        </Button>
        <span className="text-gray-400">
          Page {currentPage + 1} of {totalPages || 1}
        </span>
        <Button
          onClick={() => setCurrentPage(p => Math.min(totalPages - 1, p + 1))}
          disabled={currentPage >= totalPages - 1}
          variant="outline"
          size="sm"
          className="border-gray-600"
        >
          <ChevronRight className="w-4 h-4" />
        </Button>
      </div>
    </div>
  );
};
